import styled, { css } from "styled-components"

const paragraphStyles = css`
  font-size: ${({ theme }) => theme.font.size.l};
  margin-top: 1.6rem;

  ${({ theme }) => theme.mq.small} {
    max-width: 80%;
  }
`

const StyledHeroSection = styled.section`
  position: relative;
  display: grid;
  gap: 3.2rem;
  align-items: center;
  max-width: ${({ theme }) => theme.gridWidth};
  margin: 0 auto;
  padding: 12rem 1.6rem 4rem;

  ${({ theme }) => theme.mq.large} {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    padding-top: 12rem;
  }
`

const SectionContentWrapper = styled.div`
  position: relative;
  min-width: 0;
`

const StyledButtonWrapper = styled.div`
  margin-top: 1.6rem;
`

const TrustedBrandsWrapper = styled.div`
  margin-top: 1.6rem;
  max-width: 32rem;

  ${({ theme }) => theme.mq.medium} {
    margin-top: 4rem;
  }
`

const StyledHeroAnimation = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
  overflow: hidden;

  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`

export {
  StyledHeroSection,
  SectionContentWrapper,
  paragraphStyles,
  StyledButtonWrapper,
  TrustedBrandsWrapper,
  StyledHeroAnimation,
}
